import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forWho = ['Mujeres de 40 a 60 años en perimenopausia o menopausia.', 'Profesionales y dueñas de negocio que no pueden permitirse perder el enfoque.', 'Madres que cuidan de todos pero han olvidado cómo cuidar su propia energía.', 'Mujeres que quieren una solución práctica, basada en datos, no en promesas místicas.'];
const notForWho = ["Personas que buscan una 'pastilla mágica' sin cambiar un solo hábito.", 'Quienes no están dispuestas a dedicar 5 minutos al día a su propio bienestar.', 'Hombres o mujeres menores de 35 años (las necesidades hormonales son distintas).'];
export function WhoThisIsFor() {
  return <section className="w-full bg-taupe/10 py-20 md:py-32" data-id="element-131">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-132">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-133">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-134">
            <h2 className="text-3xl font-serif text-text-brown mb-8 tracking-wide" data-id="element-135">
              Este Kit es para ti si...
            </h2>
            <ul className="space-y-6" data-id="element-136">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-137">
                  <div className="mt-1 bg-sage/20 p-1 rounded-full text-sage flex-shrink-0" data-id="element-138">
                    <CheckIcon className="w-4 h-4" strokeWidth={3} data-id="element-139" />
                  </div>
                  <span className="text-text-brown-light leading-relaxed" data-id="element-140">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-141">
            <h2 className="text-3xl font-serif text-text-brown mb-8 tracking-wide" data-id="element-142">
              No es para ti si...
            </h2>
            <ul className="space-y-6" data-id="element-143">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-144">
                  <div className="mt-1 bg-terracotta/10 p-1 rounded-full text-terracotta flex-shrink-0" data-id="element-145">
                    <XIcon className="w-4 h-4" strokeWidth={3} data-id="element-146" />
                  </div>
                  <span className="text-text-brown-light leading-relaxed" data-id="element-147">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}